import Layout from "./include/layout";
import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { myroutes } from "../routes/webroute";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ClassesService from "./classe/ClassesService";
import { useDispatch, useSelector } from "react-redux";
import { checkAuthenticate } from "./app/providers/authSlice";
import GrillestarifairesService from "./grillestarifaires/GrillestarifairesService";
import UsersService from "./users/UsersService";
import RolesService from "./roles/RolesService";
import Filarial from "./include/filarial";
import StatutsService from "./statuts/StatutsService";
import ApprenantsService from "./apprenants/ApprenantsService";
import CivilitesService from "./civilites/CivilitesService";
import CalendriersevaluationsService from "./calendriersevaluations/CalendriersevaluationsService";
import ClassesoptionsService from "./classesoptions/ClassesoptionsService";
import EnseignantsService from "./enseignants/EnseignantsService";
import EtablissementsService from "./etablissements/EtablissementsService";
import CategoriesgrillestarifairesService from "./categoriesgrillestarifaires/CategoriesgrillestarifairesService";
import MatieresService from "./matieres/MatieresService";
import SitesService from "./sites/SitesService";
import TypesevaluationsService from "./typesevaluations/TypesevaluationsService";
import TypesinscriptionsService from "./typesinscriptions/TypesinscriptionsService";
import TranchesscolaritesService from "./tranchesscolarites/TranchesscolaritesService";
import GenresService from "./genres/GenresService";
import NiveauxService from "./niveaux/NiveauxService";
import PeriodicitesScolairesService from "./periodicitesscolaires/PeriodicitesScolairesService";
import ModesPaiementsService from "./modespaiements/ModesPaiementsService";
import StatutapprenantService from "./statutapprenants/StatutapprenantService";
import AnneesacademiquesService from "./anneesacademiques/AnneesacademiquesService";
import SexesService from "./sexes/SexesService";
import LiensParentauxService from "./liensparentaux/LiensParentauxService";
import CoursService from "./cours/CoursService";
import ProgrammesevaluationsService from "./programmesevaluations/ProgrammesevaluationsService";
import NotesService from "./notes/NotesService";
import DevoirsService from "./devoirs/DevoirsService";

export default function Parametres() {

    const [roles , setRoles] = useState(0)
    const [classes , setClasses] = useState(0)
    const [apprenants , setApprenants] = useState(0)
    const [categoriesgrillestarifaires , setCategoriesgrillestarifaires] = useState(0)
    const [classesoptions , setClassesoptions] = useState(0)
    const [enseignants , setEnseignants] = useState(0)
    const [etablissements , setEtablissements] = useState(0)
    const [grillestarifaires , setGrillestarifaires] = useState(0)
    const [habilitations , setHabilitations] = useState(0)
    const [matieres , setMatieres] = useState(0)
    const [sites , setSites] = useState(0)
    const [statuts , setStatuts] = useState(0)
    const [tranchesscolarites , seTranchesscolarites] = useState(0)
    const [typesevaluations , setTypesevaluations] = useState(0)
    const [typesinscriptions , setTypesinscriptions] = useState(0)
    const [users , setUsers] = useState(0)
    const [calendriersevaluations , setCalendriersevaluations] = useState(0)
    const [civilites , setCivilites] = useState(0)
    const [genres , setGenres] = useState(0)
    const [niveaux , setNiveaux] = useState(0)
    const [notes , setNotes] = useState(0)
    const [periodicites , setPeriodicites] = useState(0)
    const [programmesevaluations , setProgrammesevaluations] = useState(0)
    const [modespaiements , setModespaiements] = useState(0)
    const [statutsapprenants , setStatutsapprenants] = useState(0)
    const [anneesacademiques , setAnneesacademiques] = useState(0)
    const [liensparentaux , setLiensParentaux] = useState(0)
    const [cours , setCours] = useState(0)
    const [devoirs , setDevoirs] = useState(0)
    const [sexes , setSexes] = useState(0)

    const activeLink = "PARAMETRES"

    const token = useSelector(state => state.auth.token)

    const navigate = useNavigate()
    //check if user is authenticated
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(state => state.auth.isAuthenticate)

    //get liste classes
    const fetchStats = async () => {
        //get stats for classes
        await ClassesService.index(token)
            .then((res) => {
                //Créer une copie superficielle de parametresStats dans _data
                /*let _data = { ...parametresStats };
                _data['classes'] = res.data.data.classes.length;
                setParametresStats(_data);*/
                setClasses(res.data.data.classes.length)
            })
            .catch((error) => {
                console.log(error);
            });

        //get stats for grille tarifaires
        await GrillestarifairesService.index(token).then((res) => {
            //console.log(res.data.data)
            setGrillestarifaires(res.data.data.grillestarifaires.length);
        }).catch(error => {
            console.log(error)
        })

        //get stats for users
        await UsersService.index(token).then((res) => {
            //console.log(res.data.data)
            setUsers(res.data.data.users.length)
        }).catch(error => {
            console.log(error)
        })

        //get stats for roles
        await RolesService.index(token).then((res) => {
            /*let _data = { ...parametresStats };
            _data["roles"] = res.data.data.roles.length
            setParametresStats({...parametresStats})*/
            setRoles(res.data.data.roles.length)
        }).catch(error => {
            console.log(error)
        })

        //get stats for statuts
        await StatutsService.index(token).then((res) => {
            //console.log(res.data.data)
            setStatuts(res.data.data.statuts.length)
        }).catch(error => {
            console.log(error)
        })

        //get stats for apprenants
        await ApprenantsService.index(token).then((res) => {
            //console.log(res.data.data)
            setApprenants(res.data.data.apprenants.length)
        }).catch(error => {
            console.log(error)
        })

        //get stats for categorie grille tarifaire
        await CategoriesgrillestarifairesService.index(token).then((res) => {
            //console.log(res.data.data)
            setCategoriesgrillestarifaires(res.data.data.categoriesgrillestarifaires.length)
        }).catch(error => {
            console.log(error)
        })

        //get stats for civilites
        await CivilitesService.index(token).then((res) => {
            //console.log(res.data.data)
            setCivilites(res.data.data.civilites.length)
        }).catch(error => {
            console.log(error)
        })

        //get stats for genres
        await GenresService.index(token).then((res) => {
            //console.log(res.data.data)
            setGenres(res.data.data.genres.length)
        }).catch(error => {
            console.log(error)
        })


        //get stats for calendrier evaluations
        await CalendriersevaluationsService.index(token).then((res) => {
            //console.log(res.data.data)
            setCalendriersevaluations(res.data.data.calendriersevaluations.length)
        }).catch(error => {
            console.log(error)
        })

        //get stats for classes options
        await ClassesoptionsService.index(token).then((res) => {
            //console.log(res.data.data)
            setClassesoptions(res.data.data.classesoptions.length)
        }).catch(error => {
            console.log(error)
        })

        //get stats for enseignants
        await EnseignantsService.index(token).then((res) => {
            //console.log(res.data.data) 
            setEnseignants(res.data.data.enseignants.length)
        }).catch(error => {
            console.log(error)
        })

        //get stats for etablissements
        await EtablissementsService.index(token).then((res) => {
            //console.log(res.data.data)
            setEtablissements(res.data.data.etablissements.length)
        }).catch(error => {
            console.log(error)
        })

        //get stats for matieres
        await MatieresService.index(token).then((res) => {
            //console.log(res.data.data)
            setMatieres(res.data.data.matieres.length)
        }).catch(error => {
            console.log(error)
        })
        //get stats for sites
        await SitesService.index(token).then((res) => {
            //console.log(res.data.data)
            setSites(res.data.data.sites.length)
        }).catch(error => {
            console.log(error)
        })

         //get stats for tranche scolarité
         await TranchesscolaritesService.index(token).then((res) => {
            //console.log(res.data.data)
            seTranchesscolarites(res.data.data.tranchesscolarites.length)
        }).catch(error => {
            console.log(error)
        })

        //get stats for type evaluations
        await TypesevaluationsService.index(token).then((res) => {
            //console.log(res.data.data)
            setTypesevaluations(res.data.data.typesevaluations.length)
        }).catch(error => {
            console.log(error)
        })

         //get stats for type inscriptions
         await TypesinscriptionsService.index(token).then((res) => {
            //console.log(res.data.data)
            setTypesinscriptions(res.data.data.typesinscriptions.length)
        }).catch(error => {
            console.log(error)
        })

          //get stats for annes academiques
          await AnneesacademiquesService.index(token).then((res) => {
            setAnneesacademiques(res.data.data.anneesacademiques.length)
        }).catch(error => {
            console.log(error)
        })

         //get stats for niveaux
         await NiveauxService.index(token).then((res) => {
            //console.log(res.data.data)
            setNiveaux(res.data.data.niveaux.length)
        }).catch(error => {
            console.log(error)
        })


        //get stats for tranchesscolarite
        await PeriodicitesScolairesService.index(token).then((res) => {
            //console.log(res.data.data)
            setPeriodicites(res.data.data.periodicitesscolaires.length)
        }).catch(error => {
            console.log(error)
        })

             //get stats for programmes evaluations
             await ProgrammesevaluationsService.index(token).then((res) => {
                //console.log(res.data.data)
                setProgrammesevaluations(res.data.data.programmesevaluations.length)
            }).catch(error => {
                console.log(error)
            })

        //get stats for modespaiements
        await ModesPaiementsService.index(token).then((res) => {
            //console.log(res.data.data)
            setModespaiements(res.data.data.modespaiements.length)
        }).catch(error => {
            console.log(error)
        })

         //get stats for statutsapprenants
         await StatutapprenantService.index(token).then((res) => {
            //console.log(res.data.data)
            setStatutsapprenants(res.data.data.statutsapprenants.length)
        }).catch(error => {
            console.log(error)
        })

         //get stats for sexes
         await SexesService.index(token).then((res) => {
            //console.log(res.data.data)
            setSexes(res.data.data.sexes.length)
        }).catch(error => {
            console.log(error)
        })

        //get liens parentaux
        await LiensParentauxService.index(token).then((res) => {
            //console.log(res.data.data)
            setLiensParentaux(res.data.data.liensparentaux.length)
        }).catch(error => {
            console.log(error)
        })

         //get stats for cours
         await CoursService.index(token).then((res) => {
            setCours(res.data.data.cours.length)
        }).catch(error => {
            console.log(error)
        })

         //get stats for devoirs
         await DevoirsService.index(token).then((res) => {
            //console.log(res.data.data.length)
            setDevoirs(res.data.data.length)
        }).catch(error => {
            console.log(error)
        })
        

         //get stats for notes et moyennes
         await NotesService.index(token).then((res) => {
            setNotes(res.data.data.notes.length)
        }).catch(error => {
            console.log(error)
        })


    };

    useEffect(() => {
        fetchStats();
        // Vérifier si l'utilisateur est connecté lors du chargement de l'application
        dispatch(checkAuthenticate());
        if (!isAuthenticated) {
            //console.log(isAuthenticated)
            //Redirection sur le dashboard
            navigate(myroutes.login)
        }
    }, [dispatch])

    return (
        <Layout>
            {/* Content */}

            <div className="container-xxl flex-grow-1 container-p-y">

                <Filarial activeLink={activeLink} />

                <div className="shadow-lgxxx pt-4 px-4 mb-4">
                               
                    <div className="row">
                        <div className="col-lg-12 col-md-12 order-1">
                            <div className="row">

                                 {/*Apprenants*/}

                                <div className="col-lg-3 col-md-3 col-sm-12 mb-4">
                                    <Link to={myroutes.apprenants_index}>
                                        <div className="card-dash blue bg-secondaryx text-whitex">
                                            <div className="card-body">
                                                <div className="card-title d-flex align-items-start justify-content-between">
                                                    <div className="avatar flex-shrink-0">
                                                        <FontAwesomeIcon icon="fa-solid fa-users-gear" size="2xl" className="icon-color" />
                                                    </div>
                                                </div>
                                                <span className="fw-semibold d-block mb-1">Apprenants<h3 className="card-title mb-2" >{apprenants}</h3></span>
                                            </div>
                                        </div>
                                    </Link>
                                </div>


                                {/**Categories grilles tarifaires */}
                                <div className="col-lg-3 col-md-3 col-sm-12 mb-4">
                                    <Link to={myroutes.categoriesgrillestarifaires_index}>
                                        <div className="card-dash blue bg-secondaryx text-whitex">
                                            <div className="card-body">
                                                <div className="card-title d-flex align-items-start justify-content-between">
                                                    <div className="avatar flex-shrink-0">
                                                        <FontAwesomeIcon icon="fa-solid fa-users" size="2xl" className="icon-color" />
                                                    </div>
                                                </div>
                                                <span className="fw-semibold d-block mb-1">Categories grilles tarifaires<h3 className="card-title mb-2" style={{ float: "right" }}>{categoriesgrillestarifaires}</h3></span>

                                                {/*
                                            <h3 className="card-title mb-2">$12,628</h3>
                                            <small className="text-success fw-semibold"><i className="bx bx-up-arrow-alt"></i> +72.80%</small> */}
                                            </div>
                                        </div>
                                    </Link>
                                </div>

                                {/**Calendriers evaluations */}

                                <div className="col-lg-3 col-md-3 col-sm-12 mb-4">
                                    <Link to={myroutes.calendriersevaluations_index}>
                                        <div className="card-dash blue bg-secondaryx text-whitex">
                                            <div className="card-body">
                                                <div className="card-title d-flex align-items-start justify-content-between">
                                                    <div className="avatar flex-shrink-0">
                                                        <FontAwesomeIcon icon="fa-solid fa-users" size="2xl" className="icon-color" />
                                                    </div>
                                                </div>
                                                <span className="fw-semibold d-block mb-1">Calendriers Evaluations<h3 className="card-title mb-2" style={{ float: "right" }}>{calendriersevaluations}</h3></span>

                                                {/*
                                            <h3 className="card-title mb-2">$12,628</h3>
                                            <small className="text-success fw-semibold"><i className="bx bx-up-arrow-alt"></i> +72.80%</small> */}
                                            </div>
                                        </div>
                                    </Link>
                                </div>

                                {/**Civilités */}
                                <div className="col-lg-3 col-md-3 col-sm-12 mb-4">
                                    <Link to={myroutes.civilites_index}>
                                        <div className="card-dash blue bg-secondaryx text-whitex">
                                            <div className="card-body">
                                                <div className="card-title d-flex align-items-start justify-content-between">
                                                    <div className="avatar flex-shrink-0">
                                                        <FontAwesomeIcon icon="fa-solid fa-users" size="2xl" className="icon-color" />
                                                    </div>
                                                </div>
                                                <span className="fw-semibold d-block mb-1">Civilités<h3 className="card-title mb-2" style={{ float: "right" }}>{civilites}</h3></span>

                                            </div>
                                        </div>
                                    </Link>
                                </div>

                                {/*Classes*/}

                                <div className="col-lg-3 col-md-3 col-sm-12 mb-4">
                                    <Link to={myroutes.classes_index}>
                                        <div className="card-dash blue bg-secondaryx text-whitex">
                                            <div className="card-body">
                                                <div className="card-title d-flex align-items-start justify-content-between">
                                                    <div className="avatar flex-shrink-0">
                                                        <FontAwesomeIcon icon="fa-solid fa-folder-open" size="2xl" className="icon-color" />
                                                    </div>
                                                </div>
                                                <span className="fw-semibold d-block mb-1">Classes <h3 className="card-title mb-2" style={{ float: "right" }}>{classes}</h3></span>

                                            </div>
                                        </div>
                                    </Link>
                                </div>

                                {/**Classes options */}

                                <div className="col-lg-3 col-md-3 col-sm-12 mb-4">
                                    <Link to={myroutes.classesoptions_index}>
                                        <div className="card-dash blue bg-secondaryx text-whitex">
                                            <div className="card-body">
                                                <div className="card-title d-flex align-items-start justify-content-between">
                                                    <div className="avatar flex-shrink-0">
                                                        <FontAwesomeIcon icon="fa-solid fa-object-group" size="2xl" className="icon-color" />
                                                    </div>
                                                </div>
                                                <span className="fw-semibold d-block mb-1">Classes options<h3 className="card-title mb-2" style={{ float: "right" }}>{classesoptions}</h3></span>

                                            </div>
                                        </div>
                                    </Link>
                                </div>

                                {/**Cours */}

                                <div className="col-lg-3 col-md-3 col-sm-12 mb-4">
                                    <Link to={myroutes.cours_index}>
                                        <div className="card-dash blue bg-secondaryx text-whitex">
                                            <div className="card-body">
                                                <div className="card-title d-flex align-items-start justify-content-between">
                                                    <div className="avatar flex-shrink-0">
                                                        <FontAwesomeIcon icon="fa-solid fa-object-group" size="2xl" className="icon-color" />
                                                    </div>
                                                </div>
                                                <span className="fw-semibold d-block mb-1">Cours<h3 className="card-title mb-2" style={{ float: "right" }}>{cours}</h3></span>

                                            </div>
                                        </div>
                                    </Link>
                                </div>

                                {/**Devoirs */}
                                <div className="col-lg-3 col-md-3 col-sm-12 mb-4">
                                    <Link to={myroutes.devoirs_index}>
                                        <div className="card-dash blue bg-secondaryx text-whitex">
                                            <div className="card-body">
                                                <div className="card-title d-flex align-items-start justify-content-between">
                                                    <div className="avatar flex-shrink-0">
                                                        <FontAwesomeIcon icon="fa-solid fa-object-group" size="2xl" className="icon-color" />
                                                    </div>
                                                </div>
                                                <span className="fw-semibold d-block mb-1">Devoirs<h3 className="card-title mb-2" style={{ float: "right" }}>{devoirs}</h3></span>

                                            </div>
                                        </div>
                                    </Link>
                                </div>

                                {/*Enseignants */}
                                <div className="col-lg-3 col-md-3 col-sm-12 mb-4">
                                    <Link to={myroutes.enseignants_index}>
                                        <div className="card-dash yellow bg-secondaryx text-whitex">
                                            <div className="card-body">
                                                <div className="card-title d-flex align-items-start justify-content-between">
                                                    <div className="avatar flex-shrink-0">
                                                        <FontAwesomeIcon icon="fa-solid fa-person-chalkboard" size="2xl" className="icon-color" />
                                                    </div>
                                                    <div className="dropdown">
                                                        <button
                                                            className="btn p-0"
                                                            type="button"
                                                            id="cardOpt3"
                                                            data-bs-toggle="dropdown"
                                                            aria-haspopup="true"
                                                            aria-expanded="false"
                                                        >
                                                            <i className="bx bx-dots-vertical-rounded"></i>
                                                        </button>
                                                        <div className="dropdown-menu dropdown-menu-end" aria-labelledby="cardOpt3">
                                                            <Link to={myroutes.enseignants_index} className="dropdown-item">Liste</Link>
                                                            <Link to={myroutes.enseignants_create} className="dropdown-item" >Ajouter</Link>
                                                        </div>
                                                    </div>
                                                </div>
                                                <span className="fw-semibold d-block mb-1">Enseignants <h3 className="card-title mb-2" style={{ float: "right" }}>{enseignants}</h3></span>

                                            </div>
                                        </div>
                                    </Link>
                                </div>

                                <div className="col-lg-3 col-md-3 col-sm-12 mb-4">
                                    <Link to={myroutes.etablissements_index}>
                                        <div className="card-dash yellow bg-secondaryx text-whitex">
                                            <div className="card-body">
                                                <div className="card-title d-flex align-items-start justify-content-between">
                                                    <div className="avatar flex-shrink-0">
                                                        <FontAwesomeIcon icon="fa-solid fa-bars-progress" size="2xl" className="icon-color" />
                                                    </div>
                                                    <div className="dropdown">
                                                        <button
                                                            className="btn p-0"
                                                            type="button"
                                                            id="cardOpt3"
                                                            data-bs-toggle="dropdown"
                                                            aria-haspopup="true"
                                                            aria-expanded="false"
                                                        >
                                                            <i className="bx bx-dots-vertical-rounded"></i>
                                                        </button>
                                                        <div className="dropdown-menu dropdown-menu-end" aria-labelledby="cardOpt3">
                                                            <Link to={myroutes.etablissements_index} className="dropdown-item">Liste</Link>
                                                            <Link to={myroutes.etablissements_create} className="dropdown-item" >Ajouter</Link>
                                                        </div>
                                                    </div>
                                                </div>
                                                <span className="fw-semibold d-block mb-1">Etablissements <h3 className="card-title mb-2" style={{ float: "right" }}>{etablissements}</h3></span>

                                            </div>
                                        </div>
                                    </Link>
                                </div>

                                 {/**Genres */}
                                 <div className="col-lg-3 col-md-3 col-sm-12 mb-4">
                                    <Link to={myroutes.genres_index}>
                                        <div className="card-dash yellow bg-secondaryx text-whitex">
                                            <div className="card-body">
                                                <div className="card-title d-flex align-items-start justify-content-between">
                                                    <div className="avatar flex-shrink-0">
                                                        <FontAwesomeIcon icon="fa-solid fa-users" size="2xl" className="icon-color" />
                                                    </div>
                                                </div>
                                                <span className="fw-semibold d-block mb-1">Genres<h3 className="card-title mb-2" style={{ float: "right" }}>{genres}</h3></span>

                                                {/*
                                            <h3 className="card-title mb-2">$12,628</h3>
                                            <small className="text-success fw-semibold"><i className="bx bx-up-arrow-alt"></i> +72.80%</small> */}
                                            </div>
                                        </div>
                                    </Link>
                                </div>

                                {/**Grilles tarifaires */}
                                <div className="col-lg-3 col-md-3 col-sm-12 mb-4">
                                    <Link to={myroutes.grillestarifaires_index}>
                                        <div className="card-dash yellow bg-secondaryx text-whitex">
                                            <div className="card-body">
                                                <div className="card-title d-flex align-items-start justify-content-between">
                                                    <div className="avatar flex-shrink-0">
                                                        <FontAwesomeIcon icon="fa-solid fa-users" size="2xl" className="icon-color" />
                                                    </div>
                                                </div>
                                                <span className="fw-semibold d-block mb-1">Grilles tarifaires<h3 className="card-title mb-2" style={{ float: "right" }}>{grillestarifaires}</h3></span>

                                                {/*
                                            <h3 className="card-title mb-2">$12,628</h3>
                                            <small className="text-success fw-semibold"><i className="bx bx-up-arrow-alt"></i> +72.80%</small> */}
                                            </div>
                                        </div>
                                    </Link>
                                </div>


                                <div className="col-lg-3 col-md-3 col-sm-12 mb-4">
                                    <Link to={myroutes.habilitations_index}>
                                        <div className="card-dash yellow bg-secondaryx text-whitex">
                                            <div className="card-body">
                                                <div className="card-title d-flex align-items-start justify-content-between">
                                                    <div className="avatar flex-shrink-0">
                                                        <FontAwesomeIcon icon="fa-solid fa-bars-progress" size="2xl" className="icon-color" />
                                                    </div>
                                                    <div className="dropdown">
                                                        <button
                                                            className="btn p-0"
                                                            type="button"
                                                            id="cardOpt3"
                                                            data-bs-toggle="dropdown"
                                                            aria-haspopup="true"
                                                            aria-expanded="false"
                                                        >
                                                            <i className="bx bx-dots-vertical-rounded"></i>
                                                        </button>
                                                        <div className="dropdown-menu dropdown-menu-end" aria-labelledby="cardOpt3">
                                                            <Link to={myroutes.habilitations_index} className="dropdown-item" >Liste</Link>
                                                            <Link to={myroutes.habilitations_create} className="dropdown-item" >Ajouter</Link>
                                                        </div>
                                                    </div>
                                                </div>

                                                <span className="fw-semibold d-block mb-1">Habilitations <h3 className="card-title mb-2" style={{ float: "right" }}>{habilitations}</h3></span>

                                            </div>
                                        </div>
                                    </Link>
                                </div>

                                {/** Liens parentaux */}
                                <div className="col-lg-3 col-md-3 col-sm-12 mb-4">
                                    <Link to={myroutes.liensparentaux_index}>
                                        <div className="card-dash blue bg-secondaryx text-whitex">
                                            <div className="card-body">
                                                <div className="card-title d-flex align-items-start justify-content-between">
                                                    <div className="avatar flex-shrink-0">
                                                        <FontAwesomeIcon icon="fa-solid fa-book" size="2xl" className="icon-color" />
                                                    </div>
                                                </div>
                                                <span className="fw-semibold d-block mb-1">Liens parentaux <h3 className="card-title mb-2" style={{ float: "right" }}>{liensparentaux}</h3></span>
                                            </div>
                                        </div>
                                    </Link>
                                </div>

                                {/** Matières */}
                                <div className="col-lg-3 col-md-3 col-sm-12 mb-4">
                                    <Link to={myroutes.matieres_index}>
                                        <div className="card-dash blue bg-secondaryx text-whitex">
                                            <div className="card-body">
                                                <div className="card-title d-flex align-items-start justify-content-between">
                                                    <div className="avatar flex-shrink-0">
                                                        <FontAwesomeIcon icon="fa-solid fa-book" size="2xl" className="icon-color" />
                                                    </div>
                                                </div>
                                                <span className="fw-semibold d-block mb-1">Matières <h3 className="card-title mb-2" style={{ float: "right" }}>{matieres}</h3></span>

                                                {/*
                                            <h3 className="card-title mb-2">$12,628</h3>
                                            <small className="text-success fw-semibold"><i className="bx bx-up-arrow-alt"></i> +72.80%</small> */}
                                            </div>
                                        </div>
                                    </Link>
                                </div>

                                {/** Mode paiements */}
                                <div className="col-lg-3 col-md-3 col-sm-12 mb-4">
                                    <Link to={myroutes.modespaiements_index}>
                                        <div className="card-dash blue bg-secondaryx text-whitex">
                                            <div className="card-body">
                                                <div className="card-title d-flex align-items-start justify-content-between">
                                                    <div className="avatar flex-shrink-0">
                                                        <FontAwesomeIcon icon="fa-solid fa-book" size="2xl" className="icon-color" />
                                                    </div>
                                                </div>
                                                <span className="fw-semibold d-block mb-1">Modes de paiements <h3 className="card-title mb-2" style={{ float: "right" }}>{modespaiements}</h3></span>

                                                {/*
                                            <h3 className="card-title mb-2">$12,628</h3>
                                            <small className="text-success fw-semibold"><i className="bx bx-up-arrow-alt"></i> +72.80%</small> */}
                                            </div>
                                        </div>
                                    </Link>
                                </div>

                                {/** Niveaux */}
                                <div className="col-lg-3 col-md-3 col-sm-12 mb-4">
                                    <Link to={myroutes.niveaux_index}>
                                        <div className="card-dash blue bg-secondaryx text-whitex">
                                            <div className="card-body">
                                                <div className="card-title d-flex align-items-start justify-content-between">
                                                    <div className="avatar flex-shrink-0">
                                                        <FontAwesomeIcon icon="fa-solid fa-book" size="2xl" className="icon-color" />
                                                    </div>
                                                </div>
                                                <span className="fw-semibold d-block mb-1">Niveaux <h3 className="card-title mb-2" style={{ float: "right" }}>{niveaux}</h3></span>

                                                {/*
                                            <h3 className="card-title mb-2">$12,628</h3>
                                            <small className="text-success fw-semibold"><i className="bx bx-up-arrow-alt"></i> +72.80%</small> */}
                                            </div>
                                        </div>
                                    </Link>
                                </div>

                                 {/** Notes et moyennes */}
                                 <div className="col-lg-3 col-md-3 col-sm-12 mb-4">
                                    <Link to={myroutes.notes_index}>
                                        <div className="card-dash yellow bg-secondaryx text-whitex">
                                            <div className="card-body">
                                                <div className="card-title d-flex align-items-start justify-content-between">
                                                    <div className="avatar flex-shrink-0">
                                                        <FontAwesomeIcon icon="fa-solid fa-book" size="2xl" className="icon-color" />
                                                    </div>
                                                </div>
                                                <span className="fw-semibold d-block mb-1">Notes et moyennes <h3 className="card-title mb-2" style={{ float: "right" }}>{niveaux}</h3></span>

                                                {/*
                                            <h3 className="card-title mb-2">$12,628</h3>
                                            <small className="text-success fw-semibold"><i className="bx bx-up-arrow-alt"></i> +72.80%</small> */}
                                            </div>
                                        </div>
                                    </Link>
                                </div>

                                  {/** Periodicites */}
                                  <div className="col-lg-3 col-md-3 col-sm-12 mb-4">
                                    <Link to={myroutes.periodicites_index}>
                                        <div className="card-dash blue bg-secondaryx text-whitex">
                                            <div className="card-body">
                                                <div className="card-title d-flex align-items-start justify-content-between">
                                                    <div className="avatar flex-shrink-0">
                                                        <FontAwesomeIcon icon="fa-solid fa-book" size="2xl" className="icon-color" />
                                                    </div>
                                                </div>
                                                <span className="fw-semibold d-block mb-1">Périodicités Scolaires <h3 className="card-title mb-2" style={{ float: "right" }}>{periodicites}</h3></span>

                                                {/*
                                            <h3 className="card-title mb-2">$12,628</h3>
                                            <small className="text-success fw-semibold"><i className="bx bx-up-arrow-alt"></i> +72.80%</small> */}
                                            </div>
                                        </div>
                                    </Link>
                                </div>

                                       {/** Programmes evaluations */}
                                       <div className="col-lg-3 col-md-3 col-sm-12 mb-4">
                                    <Link to={myroutes.programmesevaluations_index}>
                                        <div className="card-dash yellow bg-secondaryx text-whitex">
                                            <div className="card-body">
                                                <div className="card-title d-flex align-items-start justify-content-between">
                                                    <div className="avatar flex-shrink-0">
                                                        <FontAwesomeIcon icon="fa-solid fa-book" size="2xl" className="icon-color" />
                                                    </div>
                                                </div>
                                                <span className="fw-semibold d-block mb-1">Programmes evaluations<h3 className="card-title mb-2" style={{ float: "right" }}>{programmesevaluations}</h3></span>

                                                {/*
                                            <h3 className="card-title mb-2">$12,628</h3>
                                            <small className="text-success fw-semibold"><i className="bx bx-up-arrow-alt"></i> +72.80%</small> */}
                                            </div>
                                        </div>
                                    </Link>
                                </div>

                                {/** Roles*/}
                                <div className="col-lg-3 col-md-3 col-sm-12 mb-4">
                                    <Link to={myroutes.roles_index}>
                                        <div className="card-dash blue bg-secondaryx text-whitex">
                                            <div className="card-body">
                                                <div className="card-title d-flex align-items-start justify-content-between">
                                                    <div className="avatar flex-shrink-0">
                                                        <FontAwesomeIcon icon="fa-solid fa-bars-progress" size="2xl" className="icon-color" />
                                                    </div>
                                                </div>
                                                <span className="fw-semibold d-block mb-1">Rôles <h3 className="card-title mb-2" style={{ float: "right" }}>{roles}</h3></span>

                                                {/*
                                            <h3 className="card-title mb-2">$12,628</h3>
                                            <small className="text-success fw-semibold"><i className="bx bx-up-arrow-alt"></i> +72.80%</small> */}

                                            </div>
                                        </div>
                                    </Link>
                                </div>

                                 {/*Sexes */}
                                 <div className="col-lg-3 col-md-3 col-sm-12 mb-4">
                                    <Link to={myroutes.sexes_index}>
                                        <div className="card-dash blue bg-secondaryx text-whitex">
                                            <div className="card-body">
                                                <div className="card-title d-flex align-items-start justify-content-between">
                                                    <div className="avatar flex-shrink-0">
                                                        <FontAwesomeIcon icon="fa-solid fa-window-restore" size="2xl" className="icon-color" />
                                                    </div>
                                                    <div className="dropdown">
                                                        <button
                                                            className="btn p-0"
                                                            type="button"
                                                            id="cardOpt3"
                                                            data-bs-toggle="dropdown"
                                                            aria-haspopup="true"
                                                            aria-expanded="false"
                                                        >
                                                            <i className="bx bx-dots-vertical-rounded"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <span className="fw-semibold d-block mb-1">Sexes <h3 className="card-title mb-2" style={{ float: "right" }}>{sexes}</h3></span>

                                                {/*
                                            <h3 className="card-title mb-2">$12,628</h3>
                                            <small className="text-success fw-semibold"><i className="bx bx-up-arrow-alt"></i> +72.80%</small> */}
                                            </div>
                                        </div>
                                    </Link>
                                </div>


                                {/*Sites */}
                                <div className="col-lg-3 col-md-3 col-sm-12 mb-4">
                                    <Link to={myroutes.sites_index}>
                                        <div className="card-dash blue bg-secondaryx text-whitex">
                                            <div className="card-body">
                                                <div className="card-title d-flex align-items-start justify-content-between">
                                                    <div className="avatar flex-shrink-0">
                                                        <FontAwesomeIcon icon="fa-solid fa-window-restore" size="2xl" className="icon-color" />
                                                    </div>
                                                    <div className="dropdown">
                                                        <button
                                                            className="btn p-0"
                                                            type="button"
                                                            id="cardOpt3"
                                                            data-bs-toggle="dropdown"
                                                            aria-haspopup="true"
                                                            aria-expanded="false"
                                                        >
                                                            <i className="bx bx-dots-vertical-rounded"></i>
                                                        </button>
                                                        <div className="dropdown-menu dropdown-menu-end" aria-labelledby="cardOpt3">
                                                            <Link to={myroutes.sites_index} className="dropdown-item">Liste</Link>
                                                            <Link to={myroutes.sites_create} className="dropdown-item" >Ajouter</Link>
                                                        </div>
                                                    </div>
                                                </div>
                                                <span className="fw-semibold d-block mb-1">Sites <h3 className="card-title mb-2" style={{ float: "right" }}>{sites}</h3></span>

                                                {/*
                                            <h3 className="card-title mb-2">$12,628</h3>
                                            <small className="text-success fw-semibold"><i className="bx bx-up-arrow-alt"></i> +72.80%</small> */}
                                            </div>
                                        </div>
                                    </Link>
                                </div>

                                {/*Statuts */}
                                <div className="col-lg-3 col-md-3 col-sm-12 mb-4">
                                    <Link to={myroutes.statuts_index}>
                                        <div className="card-dash blue bg-secondaryx text-whitex">
                                            <div className="card-body">
                                                <div className="card-title d-flex align-items-start justify-content-between">
                                                    <div className="avatar flex-shrink-0">
                                                        <FontAwesomeIcon icon="fa-solid fa-window-restore" size="2xl" className="icon-color" />
                                                    </div>
                                                </div>
                                                <span className="fw-semibold d-block mb-1">Statuts<h3 className="card-title mb-2" style={{ float: "right" }}>{statuts}</h3></span>

                                                {/*
                                            <h3 className="card-title mb-2">$12,628</h3>
                                            <small className="text-success fw-semibold"><i className="bx bx-up-arrow-alt"></i> +72.80%</small> */}

                                            </div>
                                        </div>
                                    </Link>
                                </div>

                                {/*Statuts apprenant */}
                                <div className="col-lg-3 col-md-3 col-sm-12 mb-4">
                                    <Link to={myroutes.statutsapprenants_index}>
                                        <div className="card-dash blue bg-secondaryx text-whitex">
                                            <div className="card-body">
                                                <div className="card-title d-flex align-items-start justify-content-between">
                                                    <div className="avatar flex-shrink-0">
                                                        <FontAwesomeIcon icon="fa-solid fa-window-restore" size="2xl" className="icon-color" />
                                                    </div>
                                                </div>
                                                <span className="fw-semibold d-block mb-1">Statuts apprenants<h3 className="card-title mb-2" style={{ float: "right" }}>{statutsapprenants}</h3></span>

                                                {/*
                                            <h3 className="card-title mb-2">$12,628</h3>
                                            <small className="text-success fw-semibold"><i className="bx bx-up-arrow-alt"></i> +72.80%</small> */}

                                            </div>
                                        </div>
                                    </Link>
                                </div>

                                {/*Tranches scolarites */}
                                <div className="col-lg-3 col-md-3 col-sm-12 mb-4">
                                    <Link to={myroutes.tranchesscolarites_index}>
                                        <div className="card-dash yellow bg-secondaryx text-whitex">
                                            <div className="card-body">
                                                <div className="card-title d-flex align-items-start justify-content-between">
                                                    <div className="avatar flex-shrink-0">
                                                        <FontAwesomeIcon icon="fa-solid fa-window-restore" size="2xl" className="icon-color" />
                                                    </div>
                                                    <div className="dropdown">
                                                        <button
                                                            className="btn p-0"
                                                            type="button"
                                                            id="cardOpt3"
                                                            data-bs-toggle="dropdown"
                                                            aria-haspopup="true"
                                                            aria-expanded="false"
                                                        >
                                                            <i className="bx bx-dots-vertical-rounded"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <span className="fw-semibold d-block mb-1">Tranches Scolarités<h3 className="card-title mb-2" style={{ float: "right" }}>{tranchesscolarites}</h3></span>

                                                {/*
                                            <h3 className="card-title mb-2">$12,628</h3>
                                            <small className="text-success fw-semibold"><i className="bx bx-up-arrow-alt"></i> +72.80%</small> */}
                                            </div>
                                        </div>
                                    </Link>
                                </div>

                                {/*Types Contrats */}
                                <div className="col-lg-3 col-md-3 col-sm-12 mb-4">
                                    <Link to={myroutes.typescontrats_index}>
                                        <div className="card-dash yellow bg-secondaryx text-whitex">
                                            <div className="card-body">
                                                <div className="card-title d-flex align-items-start justify-content-between">
                                                    <div className="avatar flex-shrink-0">
                                                        <FontAwesomeIcon icon="fa-solid fa-window-restore" size="2xl" className="icon-color" />
                                                    </div>
                                                    <div className="dropdown">
                                                        <button
                                                            className="btn p-0"
                                                            type="button"
                                                            id="cardOpt3"
                                                            data-bs-toggle="dropdown"
                                                            aria-haspopup="true"
                                                            aria-expanded="false"
                                                        >
                                                            <i className="bx bx-dots-vertical-rounded"></i>
                                                        </button>
                                                        
                                                    </div>
                                                </div>
                                                <span className="fw-semibold d-block mb-1">Types Contrats<h3 className="card-title mb-2" style={{ float: "right" }}>{typesevaluations}</h3></span>

                                                {/*
                                            <h3 className="card-title mb-2">$12,628</h3>
                                            <small className="text-success fw-semibold"><i className="bx bx-up-arrow-alt"></i> +72.80%</small> */}

                                            </div>
                                        </div>
                                    </Link>
                                </div>



                                {/*Types Evaluvations */}
                                <div className="col-lg-3 col-md-3 col-sm-12 mb-4">
                                    <Link to={myroutes.typesevaluations_index}>
                                        <div className="card-dash yellow bg-secondaryx text-whitex">
                                            <div className="card-body">
                                                <div className="card-title d-flex align-items-start justify-content-between">
                                                    <div className="avatar flex-shrink-0">
                                                        <FontAwesomeIcon icon="fa-solid fa-window-restore" size="2xl" className="icon-color" />
                                                    </div>
                                                    <div className="dropdown">
                                                        <button
                                                            className="btn p-0"
                                                            type="button"
                                                            id="cardOpt3"
                                                            data-bs-toggle="dropdown"
                                                            aria-haspopup="true"
                                                            aria-expanded="false"
                                                        >
                                                            <i className="bx bx-dots-vertical-rounded"></i>
                                                        </button>
                                                        <div className="dropdown-menu dropdown-menu-end" aria-labelledby="cardOpt3">
                                                            <Link to={myroutes.typesevaluations_index} className="dropdown-item">Liste</Link>
                                                            <Link to={myroutes.typesevaluations_create} className="dropdown-item" >Ajouter</Link>
                                                        </div>
                                                    </div>
                                                </div>
                                                <span className="fw-semibold d-block mb-1">Types Evaluations<h3 className="card-title mb-2" style={{ float: "right" }}>{typesevaluations}</h3></span>

                                                {/*
                                            <h3 className="card-title mb-2">$12,628</h3>
                                            <small className="text-success fw-semibold"><i className="bx bx-up-arrow-alt"></i> +72.80%</small> */}

                                            </div>
                                        </div>
                                    </Link>
                                </div>

                                {/*Types Inscriptions */}
                                <div className="col-lg-3 col-md-3 col-sm-12 mb-4">
                                    <Link to={myroutes.typesinscriptions_index}>
                                        <div className="card-dash yellow bg-secondaryx text-whitex">
                                            <div className="card-body">
                                                <div className="card-title d-flex align-items-start justify-content-between">
                                                    <div className="avatar flex-shrink-0">
                                                        <FontAwesomeIcon icon="fa-solid fa-window-restore" size="2xl" className="icon-color" />
                                                    </div>
                                                    <div className="dropdown">
                                                        <button
                                                            className="btn p-0"
                                                            type="button"
                                                            id="cardOpt3"
                                                            data-bs-toggle="dropdown"
                                                            aria-haspopup="true"
                                                            aria-expanded="false"
                                                        >
                                                            <i className="bx bx-dots-vertical-rounded"></i>
                                                        </button>
                                                        <div className="dropdown-menu dropdown-menu-end" aria-labelledby="cardOpt3">
                                                            <Link to={myroutes.typesinscriptions_index} className="dropdown-item">Liste</Link>
                                                        </div>
                                                    </div>
                                                </div>
                                                <span className="fw-semibold d-block mb-1">Types Inscriptions<h3 className="card-title mb-2" style={{ float: "right" }}>{typesinscriptions}</h3></span>

                                                {/*
                                            <h3 className="card-title mb-2">$12,628</h3>
                                            <small className="text-success fw-semibold"><i className="bx bx-up-arrow-alt"></i> +72.80%</small> */}
                                            </div>
                                        </div>
                                    </Link>
                                </div>

                                <div className="col-lg-3 col-md-3 col-sm-12 mb-4">
                                    <Link to={myroutes.users_index}>
                                        <div className="card-dash blue bg-secondaryx text-whitex">
                                            <div className="card-body">
                                                <div className="card-title d-flex align-items-start justify-content-between">
                                                    <div className="avatar flex-shrink-0">
                                                        <FontAwesomeIcon icon="fa-solid fa-users" size="2xl" className="icon-color" />
                                                    </div>
                                                    <div className="dropdown">
                                                        <button
                                                            className="btn p-0"
                                                            type="button"
                                                            id="cardOpt3"
                                                            data-bs-toggle="dropdown"
                                                            aria-haspopup="true"
                                                            aria-expanded="false"
                                                        >
                                                            <i className="bx bx-dots-vertical-rounded"></i>
                                                        </button>
                                                        <div className="dropdown-menu dropdown-menu-end" aria-labelledby="cardOpt3">
                                                            <Link to={myroutes.users_index} className="dropdown-item">Liste</Link>
                                                            <Link to={myroutes.users_create} className="dropdown-item" >Ajouter</Link>
                                                        </div>
                                                    </div>
                                                </div>
                                                <span className="fw-semibold d-block mb-1">Utilisateurs<h3 className="card-title mb-2" style={{ float: "right" }}>{users}</h3></span>

                                                {/*
                                            <h3 className="card-title mb-2">$12,628</h3>
                                            <small className="text-success fw-semibold"><i className="bx bx-up-arrow-alt"></i> +72.80%</small> */}
                                            </div>
                                        </div>
                                    </Link>
                                </div>


                            </div>

                        </div>
                    </div>
                </div>
            </div>
            {/*End Level 2*/}
            {/* / Content */}
        </Layout>
    )
}